<template>
  <Layout>
    <PageHeader v-if="merchantData" :title="merchantData.name" :items="items" />
    <span>{{ merchId }}</span>
    <div class="row">
      <div class="col-6">
        <div class="mb-3">
          <select
                      class="form-select"
                      id="formrow-inputState"
                      v-model="selectedReseller"
                    @change="updateReseller($event)"
                    >
                    <option value=null  selected>Select a reseller</option>
                    <option v-for="reseller in resellers" :value="reseller.id" :key="reseller.id">
                      <div class="flex-grow-1">
                <h5 class="font-size-13 mb-1">{{reseller.name}}</h5>
              </div>
                    </option>
                  </select>
        </div>
      </div>
    </div>
  
    <b-modal
      v-model="showModal"
      title="Add Inventory"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
    >
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <b-form-group
                    class="mb-3 form-label"
                    id="input-group-1"
                    label="Hardware"
                    label-for="formrow-inputState"
                  >
                  <div v-if="selectedCuriHardware.buyPrice" class="d-flex mb-4">
              <div class="me-3">
                <img
                  class="media-object rounded-circle avatar-xs"
                  alt
                  :src="selectedCuriHardware.img"
                />
              </div>
              <div class="flex-grow-1">
                <h5 class="font-size-13 mb-1">{{selectedCuriHardware.name}}</h5>
                <p class="text-muted mb-1">{{selectedCuriHardware.desc}}</p>
              </div>
            </div>
                    <select
                      class="form-select"
                      id="formrow-inputState"
                      v-model="selectedCuriHardware"
                    >
                    <option v-for="cHardware in curiHardware" :value="cHardware" :key="cHardware.id">
                      <div class="flex-grow-1">
                <h5 class="font-size-13 mb-1">{{cHardware.name}}</h5>
                <p class="text-muted mb-1">{{cHardware.desc}}</p>
              </div>
                    </option>
                  </select>
                  </b-form-group>
            </div>
            <div v-if="selectedCuriHardware.buyPrice" class="mb-3">
              <div class="flex-grow-1">
                <h5 class="font-size-13 mb-1">${{calRentPrice().toFixed(2)}} E.C / month (30%)</h5>
                <p class="text-muted mb-1">${{selectedCuriHardware.buyPrice}} E.C Buy Price</p>
              </div>
            </div>
            <div class="mb-3">
              <label for="name">Model Number</label>
              <input
              required 
                id="modelNum"
                v-model="modelNum"
                type="text"
                class="form-control"
                placeholder="Model #"
              />
            </div>
                          <div class="mb-3">{{errorMsg}}</div>
          </div>
        </div>

        <div class="text-end pt-5 mt-3">
          <b-button variant="light" @click="hideModal">Close</b-button>
          <b-button type="submit" variant="success" class="ms-1"
            >{{isLoading ? 'please wait...':'Add Item'}}</b-button
          >
        </div>
      </form>
    </b-modal>
    <b-modal
    v-model="showStatusModal"
      title="Change status"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
    >
      <form @submit.prevent="handleNewStatus">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <b-form-group
                    class="mb-3 form-label"
                    id="input-group-1"
                  >
                    <b-form-select
                      class="form-select"
                      id="formrow-inputState"
                      v-model="newStatus"
                      :options="['active', 'inactive', 'pending', 'damaged']"
                    >
                  </b-form-select>
                  </b-form-group>
            </div>
          </div>
        </div>

        <div class="text-end pt-5 mt-3">
          <b-button type="submit" variant="success" class="ms-1"
            >{{isLoading ? 'please wait...':'Update'}}</b-button
          >
        </div>
      </form>
    </b-modal>
    <div>
        <a @click="markAsHardware()" v-b-tooltip.hover title="hardware">
                            <i v-if="hardwareCompanies.includes(merchId)" class="bx bx-devices" style="color: #f9be00;cursor: pointer;">Toggle Hardware</i>
                            <i v-else class="bx bx-devices" style="color: gainsboro;cursor: pointer;">Toggle Hardware</i>
                          </a>
    </div>
    <div v-if="hardwareCompanies.includes(merchId)" class="row">
        <div class="col-lg-6">
            <div class="row">
                <div class="col-lg-12 text-end" style="padding-bottom:10px;">
                    <button @click="showModel" class="btn btn-primary btn-sm">Add Hardware</button>
                </div>
            </div>
        <div v-if="hardwareList.length > 0" class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Hardware Total: ${{totalRentPrice()}} / month</h4> 
            <div v-for="hardware in hardwareList" :key="hardware.id" class="d-flex mb-4">
              <div class="me-3">
                <img
                  class="media-object rounded-circle avatar-xs"
                  alt
                  :src="hardware.hardware.img"
                />
              </div>
              <div class="flex-grow-1">
                <h5 class="font-size-13 mb-1">{{hardware.hardware.name}}</h5>
                <p class="text-muted mb-1">{{hardware.hardware.desc}}</p>
                <p class="text-muted mb-1">Model #: {{hardware.modelNumber}}</p>
                <p v-if="hardware.whoMaintained" class="text-muted mb-1 text-success">Last maintained: {{hardware.lastMaintained.toDate().toLocaleDateString("en-US", this.options)}} by <strong>{{hardware.whoMaintained}}</strong></p>
              </div>
              <div class="ms-3 text-center">
                <h5 class="font-size-13 mb-1">${{hardware.rentPrice}} / month</h5>
                <!-- <h5 class="font-size-13 mb-1"> Buy: ${{hardware.buyPrice}}</h5> -->
                <h5 v-if="hardware.status == 'active'" class="font-size-13 mb-1 text-success">{{hardware.status}}</h5>
                <h5 v-else class="font-size-13 mb-1 text-danger" style="padding:10px;">{{hardware.status}}</h5>
                <a style="cursor:pointer;" @click="showStatusM(hardware)" class="text-primary">Change Status...</a>
                <button @click="deleteHardware(hardware)" class="btn btn-primary btn-sm">Delete</button>
              </div>
            </div>
            
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Enter Special Price (optional)</h4> 
            <p class="text-danger">if this is not 0 it overwrites the hardware price!</p>
            <div class="d-flex mb-4">
              <form @submit.prevent="submitOverwritePrice">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <b-form-group
                    class="mb-3 form-label"
                    id="input-group-1"
                    label="Enter Total Price for hardware"
                    label-for="formrow-inputState"
                  >
                  <input
                  required
                id="exceptionalPrice"
                v-model="exceptionalPrice"
                type="number"
                class="form-control"
                placeholder="0.00"
              />
                  </b-form-group>
            </div>
          </div>
        </div>

        <div class="text-end pt-5 mt-3">
          <b-button type="submit" variant="success" class="ms-1"
            >{{isLoading ? 'please wait...':'Update price'}}</b-button
          >
        </div>
      </form>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
    import PageHeader from "@/components/page-header";
    import Layout from "../../layouts/main";
    import appConfig from "@/app.config";
    import firebase from 'firebase/app';

export default {
    page: {
    title: "Merchant details",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data(){
    return {
      exceptionalPrice: 0,
      showStatusModal: false,
      isLoading: false,
      newStatus: 'active',
      options: {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      },
      selectedHardware: {},
      selectedCuriHardware: {},
      modelNum: "",
      showModal: false,
      errorMsg: "",
      curiHardware: [],
      resellers: [],
      selectedReseller: null,
    hardwareCompanies: [],
    hardwareList: [],
    merchantData: {},
      items: [
        {
          text: "Details",
          href: "/"
        },
        {
          text: "Details",
          active: true
        }
      ],
      merchId: ""
  }
  },
  methods: {
    updateReseller(){
      firebase.firestore().collection("users").doc(this.merchId).update(
        {
          reseller:this.selectedReseller
        }
      )
    },
    async getAllResellers(){
      await firebase.firestore().collection("reseller_companies").where("isEnabled", "==", true).get().then((allData)=>{

        allData.docs.forEach((rData)=>{
          var data = {
            id: rData.id,
            name: rData.data().companyName
        }
        this.resellers.push(data);
        })
        
      })
    },
    totalRentPrice(){
      var total = 0
      this.hardwareList.forEach((item)=>{
        total = total + item.rentPrice
      })
      return total.toFixed(2)
    },
    async submitOverwritePrice(){
      this.isLoading = true
      if(isNaN(this.exceptionalPrice)){
        this.exceptionalPrice = 0
      }
      await firebase.firestore().collection("users").doc(this.merchId).update({
        exceptionalHardwarePrice: parseFloat(this.exceptionalPrice ?? 0)
      })
      this.isLoading = false
      this.getMerchantData()
    },
    calRentPrice(){
      return ((30/100) * parseFloat(this.selectedCuriHardware.buyPrice))
    },
    resetItems(){
      this.selectedCuriHardware = {}
      this.isLoading = false
    },
    async handleNewStatus(){
      this.isLoading = true
      await firebase.firestore().collection("merchantHardware").doc(this.selectedHardware.id)
      .update({
        status: this.newStatus
      }).then(()=>{
        this.isLoading = false
        this.selectedHardware = {}
        this.showStatusModal = false
        this.getMyHardware()
      })
    },
    async handleSubmit(){
      if(this.modelNum == "" || this.modelNum == undefined){
        this.errorMsg = "enter model number"
        return;
      }
      this.isLoading = true
      await firebase.firestore().collection("merchantHardware").add({
        ownerId: this.merchId,
        rentPrice: this.calRentPrice(),
        hardwareId: this.selectedCuriHardware.id,
        hardware: this.selectedCuriHardware,
        modelNumber: this.modelNum,
        created: firebase.firestore.FieldValue.serverTimestamp(),
        status: "active", // inactive, damaged, pending,
        lastMaintained: firebase.firestore.FieldValue.serverTimestamp(),
        whoMaintained: null
      })
      this.getMyHardware();
      this.hideModal()
    },
    hideModal(){
      this.resetItems()
        this.showModal = false;
    },
    showStatusM(h){
      this.selectedHardware = h;
      this.showStatusModal = true;
    },
    showModel(){
      this.resetItems()
        this.showModal = true;
    },
    async getCuriHardware(){
      await firebase.firestore().collection("curi_hardware").where("isAvailable", "==", true)
      .get().then((hData)=>{
        hData.docs.forEach((hDoc)=>{
          var data = hDoc.data()
          data.id = hDoc.id
          this.curiHardware.push(data)
        })
      })
    },
    async getMerchantData(){
        await firebase.firestore().collection("users").doc(this.merchId).get().then((data)=>{
            this.merchantData = data.data();
            this.selectedReseller = this.merchantData.reseller ?? null;
            this.exceptionalPrice = this.merchantData.exceptionalHardwarePrice == null || this.merchantData.exceptionalHardwarePrice == undefined ? 0 : this.merchantData.exceptionalHardwarePrice
        })
    },
    deleteHardware(data){
        // eslint-disable-next-line no-console
        // console.log("merchId ", merchId)
        this.$bvModal.msgBoxConfirm("Delete hardware ?")
        .then(async (value)=>{
            if(value == true){
                // eslint-disable-next-line no-console
                await firebase.firestore().collection("merchantHardware")
                .doc(data.id).delete().then(()=>{
                    this.getMyHardware()
                    this.resetItems()
                })
            }
        })
    },
    markAsHardware(){
        // eslint-disable-next-line no-console
        // console.log("merchId ", merchId)
        var isIncluded = this.hardwareCompanies.includes(this.merchId);
        this.$bvModal
        .msgBoxConfirm(isIncluded == true ? "Remove from hardware company list ?": "Add as company with hardware ?")
        .then(async (value)=>{
            if(value == true){
                // eslint-disable-next-line no-console
                console.log("test");
                await firebase.firestore().collection("globalSettings")
                .doc("hardwareMerchants").update({
                    merchants: isIncluded == true ?
                    firebase.firestore.FieldValue.arrayRemove(this.merchId):
                    firebase.firestore.FieldValue.arrayUnion(this.merchId)
                }).then(()=>{
                    location.reload();
                })
            }
        })
    },
    async getHardwareData(){
        await firebase.firestore().collection("globalSettings")
        .doc("hardwareMerchants").get().then((data)=>{
            this.hardwareCompanies = data.data().merchants;
        })
    },
    async getMyHardware(){
      this.hardwareList = []
        await firebase.firestore().collection("merchantHardware").where("ownerId", "==", this.merchId)
        .get().then((hData)=>{
            if(hData.size > 0){
                hData.docs.forEach((element)=>{
                    var data = element.data()
            data.id = element.id
            this.hardwareList.push(data)
                })
            }else{
              this.hardwareList = []
            }
            
        })
},
  },
  created(){
    const url = new URL(window.location.href);
    if(url){
        this.merchId = url.searchParams.get("merchId");
        if(this.merchId){
          this.getAllResellers();
            this.getMyHardware(this.merchId);
            this.getMerchantData()
            this.getCuriHardware()
    this.getHardwareData()
        }
        
    }
  }

}
</script>

<style>

</style>